import React, { useState, useEffect } from 'react';

import date from '../../../assets/images/date.svg';
import contact from '../../../assets/images/contact.svg';
import commentaire from '../../../assets/images/commentaire.svg';
import moment from '../../../assets/images/moment.svg';
import heure from '../../../assets/images/heure.svg';
import qr from '../../../assets/images/qr-code.svg';
import lieu from '../../../assets/images/lieu-rdv.svg';
import {urlBase} from "../../../config/Globals";

export const DetailProspectionProspection = ({ commune }) => {
    const secteurs = commune?.prospection_collective?.secteurs || [];
    const periodesIn = commune?.prospection_individuelle?.periodes || [];
    const secteursIn = commune?.prospection_individuelle?.secteurs || [];
    const [activeSecteurId, setActiveSecteurId] = useState(secteurs[0]?.id);

    useEffect(() => {
        if (secteurs.length > 0 && !activeSecteurId) {
            setActiveSecteurId(secteurs[0].id);
        }
    }, [commune, secteurs, activeSecteurId]);

    if (secteurs.length === 0) {
        return <p>Aucun secteur disponible.</p>;
    }

    return (
        <div className="w-100">

            <h3 className="m-0 p-2 bg-light text-center fw-sb text-dark fs-4 position-relative pb-2">
                Prospections individuelles
            </h3>
            {periodesIn && periodesIn.length > 0 ? (
                periodesIn.map((periode) => (
                <div key={periode.id} className="bg-white border-0 p-4 mb-5">
                    <div className="row mx-0 g-4 text-center pb-4" style={{borderColor: '#F9C977 !important'}}>
                        <div className="col-6 col-md-6 col-lg-3 custom-v-border">
                            <img src={date} alt="Date début" className="mb-2"
                                 style={{width: '40px', height: '70px', objectFit: 'contain'}}/>
                            <div className="fw-b text-dark">Date début</div>
                            <div className="text-secondary">{new Date(periode.date_debut).toLocaleDateString('fr-FR')}</div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-3">
                            <img src={date} alt="Date fin" className="mb-2"
                                 style={{width: '40px', height: '70px', objectFit: 'contain'}}/>
                            <div className="fw-b text-dark">Date fin</div>
                            <div className="text-secondary">{new Date(periode.date_fin).toLocaleDateString('fr-FR')}</div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start border-lg-start custom-resp-border2">
                            <img src={contact} alt="Responsable communal" className="flex-shrink-0" style={{width: 35, height: 70, objectFit: 'contain'}}/>
                            <div className="d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start">
                                <h4 className="fw-b text-dark fs-6 mb-1">Responsable communal</h4>
                                {
                                    secteursIn && secteursIn.map((secteur) => (
                                        <>
                                            <p className="text-secondary mb-3">{secteur.responsables[0].prenom+' '+secteur.responsables[0].nom}</p>
                                            <a href={urlBase + "contact?uuid="+secteur.responsables[0].id} className="btn btn-outline-custom py-2 px-3">Contacter</a>
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                        <div
                            className="col-12 col-md-6 col-lg-3 d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start border-md-start custom-resp-border">
                            <img src={commentaire} alt="Commentaire" className="flex-shrink-0" style={{width: 40, height: 70}}/>
                            <div>
                                <h4 className="fw-b text-dark fs-6 mb-1">Commentaire</h4>
                                <p className="text-secondary">{periode.commentaire ? periode.commentaire : 'Aucun commmentaire'}</p>
                            </div>
                        </div>
                    </div>
                </div>
                ))
            ) : (
                <div className="bg-white border-0 p-4 mb-5 text-center text-muted">
                    Aucune période de prospection
                </div>
            )}

            <h3 className="m-0 p-2 bg-light text-center fw-sb text-dark fs-4 position-relative pb-2 border-bottom">
                Prospections collectives
            </h3>
            {secteurs.length > 1 && (
                <ul
                    className="nav nav-pills border-0 w-100 text-center mb-4 row g-0 rounded-0 overflow-hidden"
                    id="secteurTab"
                    role="tablist"
                >
                    {secteurs.map((secteur) => (
                        <li key={secteur.id} className="nav-item col-6" role="presentation">
                            <button
                                className={`nav-link w-100 rounded-0 px-3 py-4 fw-b text-dark custom-subtab-btn ${activeSecteurId === secteur.id ? 'active' : ''}`}
                                id={`tab-${secteur.id}`}
                                type="button"
                                role="tab"
                                aria-controls={`pane-${secteur.id}`}
                                aria-selected={activeSecteurId === secteur.id}
                                onClick={() => setActiveSecteurId(secteur.id)}
                            >
                                {secteur.nom}
                            </button>
                        </li>
                    ))}
                </ul>
                )
            }
            <div className="tab-content border-0" id="secteurTabContent">
                {secteurs.map((secteur) => (
                    <div
                        key={secteur.id}
                        className={`tab-pane fade ${activeSecteurId === secteur.id ? 'show active' : ''}`}
                        id={`pane-${secteur.id}`}
                        role="tabpanel"
                        aria-labelledby={`tab-${secteur.id}`}
                    >
                        <p className="py-2 col-12 bg-white fs-6 text-center text-dark small mb-5">
                            Fait partie de la tournée suivante : <strong>{secteur.tournee?.nom}</strong>
                        </p>
                        {
                            secteur.rendez_vous && secteur.rendez_vous.length > 0 ? (
                                secteur.rendez_vous.map((rdv) => (
                                    <div key={rdv.id} className="bg-white border-0 p-4 mb-5">
                                        <div className="d-flex gap-3 mb-4 justify-content-between col-12">
                                            <span className={rdv.statut == 'ANNULE' ? 'bg-danger text-white d-flex align-items-center badge fw-sb rounded-pill text-dark px-4 py-2 xsmall' : 'bg-success d-flex align-items-center badge fw-sb rounded-pill text-dark px-4 py-2 text-white  xsmall'}>{rdv.statut}</span>
                                            <span className="d-flex align-items-center fw-sb text-dark px-4 py-2 small text-uppercase">{rdv.nature === "VALIDATION" ? "Prospection de contrôle/validation" : rdv.nature}</span>
                                            <a href={urlBase + "contact?uuid=" + secteur.responsables[0].id} className="btn btn-outline-custom py-2 px-3">Contacter</a>
                                        </div>
                                        <div className="row mx-0 g-4 text-center border-bottom pb-4 mb-4"
                                             style={{borderColor: '#F9C977 !important'}}>
                                            <div className="col-6 col-md-3 custom-v-border">
                                                <img src={date} alt="Date fin" className="mb-2" style={{width: '40px', height: '70px', objectFit: 'contain'}}/>
                                                <div className="fw-b text-dark">Date</div>
                                                <div className="text-secondary">{new Date(rdv.date).toLocaleDateString('fr-FR')}</div>
                                                {rdv.remplace_rdv_du && (
                                                    <div className="x-small opacity-50">
                                                        <i>Remplace rdv du {new Date(rdv.remplace_rdv_du).toLocaleDateString('fr-FR')}</i>
                                                    </div>
                                                    )
                                                }
                                            </div>
                                            <div className="col-6 col-md-3 custom-v-border">
                                                <img src={moment} alt="Moment" className="mb-2" style={{width: '50px', height: '70px', objectFit: 'contain'}}/>
                                                <div className="fw-b text-dark">Moment</div>
                                                <div className="text-secondary">{rdv.moment}</div>
                                            </div>
                                            <div className="col-6 col-md-3 custom-v-border">
                                                <img src={heure} alt="Heure" className="mb-2" style={{width: '45px', height: '70px', objectFit: 'contain'}}/>
                                                <div className="fw-b text-dark">Heure</div>
                                                <div className="text-secondary">{rdv.heure.slice(0, 5)}</div>
                                            </div>
                                            <div className="col-6 col-md-3">
                                                <img src={qr} alt="QR Code" className="mb-2" style={{width: '30px', height: '70px', objectFit: 'contain'}}/>
                                                <div className="fw-b text-dark">QR Code</div>
                                                <div className="text-secondary">{rdv.qrcode == true ? 'Oui' : 'Non'}</div>
                                            </div>
                                        </div>

                                        <div className="row g-4 pt-2 pb-4">
                                            <div className="col-12 col-md-4 d-flex flex-column align-items-center align-items-md-start text-center text-md-start">
                                                <img src={lieu} alt="Lieu de rdv" className="flex-shrink-0" style={{width: '50px', height: '70px', objectFit: 'contain'}}/>
                                                <div>
                                                    <h4 className="fw-b text-dark fs-6 mb-1">Lieu de rdv</h4>
                                                    <p className="text-secondary">{rdv.lieu}</p>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 d-flex flex-column  align-items-center align-items-md-start text-center text-md-start border-md-start custom-resp-border">
                                                <img src={contact} alt="Responsable communal" className="flex-shrink-0" style={{width: '35px', height: '70px', objectFit: 'contain'}}/>
                                                <div className="d-flex flex-column align-items-center align-items-md-start text-center text-md-start">
                                                    <h4 className="fw-b text-dark fs-6 mb-1">Responsable communal</h4>
                                                    <p className="text-secondary mb-3">{secteur.responsables[0].prenom+' '+secteur.responsables[0].nom}</p>
                                                </div>
                                            </div>
                                            <div
                                                className="col-12 col-md-4 d-flex flex-column align-items-center align-items-md-start text-center text-md-start border-md-start custom-resp-border">
                                                <img src={commentaire} alt="Commentaire" className="flex-shrink-0" style={{width: 40, height: 70}}/>
                                                <div>
                                                    <h4 className="fw-b text-dark fs-6 mb-1">Commentaire</h4>
                                                    <p className="text-secondary" style={{ whiteSpace: 'pre-line' }}>{rdv.commentaire ? rdv.commentaire : 'Aucun commentaire'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="bg-white border-0 p-4 mb-5 text-center text-muted">
                                    Aucune période de prospection
                                </div>
                            )}
                    </div>
                ))}
            </div>
        </div>
    );
};